import { createSlice } from '@reduxjs/toolkit';
import { revertAll } from './userReducer';

type EmployeesWorking ={
	name: string;
	picture: string;
}

interface ProjectState {
	'projectName': string;
	'createdAt': number;
	'employeesWorking': EmployeesWorking[];
	'projectDescription': string,
	'projectSlackChannel': string,
	'projectLead': string;
	'projectManger': string;
	'projectStatus': boolean,
	'startDate': number;
	'displayProjectName': string;
}

const initialState: ProjectState[] = [];

const projectsReducer = createSlice({
	name: 'projects',
	initialState,
	reducers: {
		setProjects: (state, action) => {
			state = action.payload;
			return state;
		},
		addProject: (state,action)=>{
			state = [action.payload,...state];
			return state;
		},
		updateProject: (state, action) => {

			const indexOfProjectToChange = state.findIndex(project => project.projectName === action.payload.projectName);
			const changedProject = action.payload;

			state[indexOfProjectToChange] = changedProject;
			return state;
		},
		deleteProject: (state, action) => {

			const indexOfProjectToDelete = state.findIndex(report => report.projectName === action.payload);

			if (indexOfProjectToDelete !== -1) {

				// removing item using slice since its faster than filter
				state = [...state.slice(0, indexOfProjectToDelete), ...state.slice(indexOfProjectToDelete + 1)];
			}
			return state;
		}
	},
	extraReducers(builder) {
		builder
			.addCase(revertAll, () => initialState);
	}
});

export const { setProjects , addProject, updateProject} = projectsReducer.actions;
export default projectsReducer;
